export const uniqueRanches = (ranches) => {
  const seen = new Set();
  return (ranches || []).filter((r) => {
    if (seen.has(r.ranch_number)) return false;
    seen.add(r.ranch_number);
    return true;
  });
};

export const ranchLabel = (r) => (r ? `${r.ranch_number} · ${r.name}` : "—");

export const repRanchId = (ranches, id) => {
  if (!id) return id;
  const cur = (ranches || []).find((r) => r.id === id);
  if (!cur) return id;
  const rep = uniqueRanches(ranches).find((r) => r.ranch_number === cur.ranch_number);
  return rep ? rep.id : id;
};
